import { render, staticRenderFns } from "./sgk-parameters.vue?vue&type=template&id=032ea37d&"
import script from "./sgk-parameters.vue?vue&type=script&lang=js&"
export * from "./sgk-parameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports